import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useUserStore = defineStore("user", () => {
  const token = ref(null);
  const unionid = ref(null);
  const isLogin = computed(() => !!token.value);

  const setToken = (newToken) => {
    token.value = newToken;
    if (newToken) {
      localStorage.setItem("token", newToken);
    } else {
      localStorage.removeItem("token");
    }
  };

  const setUnionid = (newUnionid) => {
    unionid.value = newUnionid;
    if (newUnionid) {
      localStorage.setItem("unionid", newUnionid);
    } else {
      localStorage.removeItem("unionid");
    }
  };

  const initToken = () => {
    const savedToken = localStorage.getItem("token");
    const savedUnionid = localStorage.getItem("unionid");
    if (savedToken) {
      token.value = savedToken;
    }
    if (savedUnionid) {
      unionid.value = savedUnionid;
    }
  };

  const logout = () => {
    token.value = null;
    unionid.value = null;
    localStorage.removeItem("token");
    localStorage.removeItem("unionid");
  };

  // 初始化时读取本地存储的数据
  initToken();

  return {
    token,
    unionid,
    isLogin,
    setToken,
    setUnionid,
    logout,
  };
});
